export let colour_swatches = [];
export let primary_color = "";
export let secondary_color = "";
export let button_color = "";
export let background_layer_color = "";
export let titles_and_sections_color = "";

export function setObject(string, value){
    return this[string] = Object.assign({},value);
}

export function setArray(string, value) {
    this[string] = Object.assign([], value);
}

export function set(string, value){
    this[string] =  value;
}


/** WEBPACK FOOTER **
 ** ./src/models/colourModels.js
 **/